import { storyblokEditable } from 'gatsby-source-storyblok';
import React from 'react';
import CustomLink from '../../CustomLink/CustomLink';
import StoryblokLinkProvider from '../../Utils/StoryblokLinkProvider/StoryblokLinkProvider';
import { LinkProps } from '../../../interfaces/LinkProps.interface';

const FooterNavItem: React.FC<LinkProps> = (props) => {
  return (
    <li>
      <StoryblokLinkProvider
        link={props.link}
        render={(link, target) => (
          <div {...storyblokEditable(props)}>
            <CustomLink
              url={link}
              label={props.label}
              target={target}
              className="text-text/body hover:text-text/body-accent"
            >
              {props.label}
            </CustomLink>
          </div>
        )}
      />
    </li>
  );
};

export default FooterNavItem;
